export default {"src":"/_next/static/media/logo-light.74218e04.svg","height":148,"width":507,"blurWidth":0,"blurHeight":0};